import { Tab, Tabs, Typography } from '@material-ui/core'
import { useSearchParams } from 'react-router-dom'

import { Herbicides } from './herbicides'
import { useStyles } from './styles'

const tabs = {
  0: Herbicides,
}

export function OperationCosts() {
  const classes = useStyles()

  const [searchParams, setSearchParams] = useSearchParams()

  const tab = searchParams.get('tab') || 0

  function handleChange(_: unknown, newValue: number) {
    setSearchParams({ tab: String(newValue) })
  }

  const CurrentTab = tabs[tab as keyof typeof tabs]

  return (
    <>
      <Typography variant='h1'>Custos de operação</Typography>
      <Tabs
        value={Number(tab)}
        onChange={handleChange}
        classes={{
          root: classes.tabRoot,
          indicator: classes.tabIndicator,
        }}
      >
        <Tab label='herbicidas' />
      </Tabs>

      {CurrentTab && <CurrentTab />}
    </>
  )
}
